// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1AG5G","container":"styles_container__3ePJl","title":"styles_title__r9yFO","wrapper":"styles_wrapper__1Wjv9","answer":"styles_answer__21bzB"};